// src/components/dashboard/MetricCard.js

import React from 'react';

/**
 * Presentational metric card used on the admin dashboard (4-up grid):
 * icon + uppercase label, a big number (or "…" while loading), and an
 * optional sub-label (e.g. "jetzt" / "von 31").
 *
 * Purely presentational — no data fetching, no context access. Callers
 * (CompanyDashboard.js, VacationMetricCard.js) own the data.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.icon - icon element (e.g. <RiTeamLine />)
 * @param {string} props.label - uppercase label text (e.g. "Mitarbeiter")
 * @param {number|string} props.value - the big number to display
 * @param {string} [props.sublabel] - small text under the number (e.g. "jetzt")
 * @param {boolean} [props.loading] - shows "…" instead of value while true
 * @param {string} [props.accent] - optional accent modifier (e.g. "periwinkle")
 */
const MetricCard = ({ icon, label, value, sublabel, loading = false, accent }) => {
  return (
    <div className={`metric-card${accent ? ` metric-card--${accent}` : ''}`}>
      <div className="metric-card-header">
        {icon && <span className="metric-card-icon">{icon}</span>}
        <span className="metric-card-label">{label}</span>
      </div>

      <p className="metric-card-value">
        {loading ? <span className="loading-number">…</span> : value}
      </p>

      {sublabel && <span className="metric-card-sublabel">{sublabel}</span>}
    </div>
  );
};

export default MetricCard;